import type { Config } from '@/workflow-runner/_contract/config';
import type { RuntimeState } from '@/workflow-runner/_contract/runtime';
import type { WorkflowSceneDirectionCatalogs } from '@/workflow-runner/_contract/sceneDirection';

const configs = new WeakMap<Config, Map<string, {
    default?: Config;
    byDirection: WeakMap<WorkflowSceneDirectionCatalogs, Config>;
}>>();

export function withWorkflowSceneConfig(config: Config, state: RuntimeState): Config {
    const mode = state.sceneOperationPresentationMode;
    const directions = state.episode ? state.sceneDirectionCatalogs : undefined;
    if (!mode && !directions && !config.adapterModeConfig.sceneDirectionCatalogs) return config;
    if ((!mode || mode === config.adapterModeConfig.workflowStateEntries?.operationPresentationMode)
        && directions === config.adapterModeConfig.sceneDirectionCatalogs) return config;
    let byMode = configs.get(config);
    if (!byMode) configs.set(config, byMode = new Map());
    const modeKey = mode ?? '';
    let variants = byMode.get(modeKey);
    if (!variants) byMode.set(modeKey, variants = { byDirection: new WeakMap() });
    let resolved = directions ? variants.byDirection.get(directions) : variants.default;
    if (!resolved) {
        resolved = { ...config, adapterModeConfig: { ...config.adapterModeConfig,
            sceneDirectionCatalogs: directions,
            ...(mode ? { workflowStateEntries: { ...config.adapterModeConfig.workflowStateEntries, operationPresentationMode: mode } } : {}) } };
        if (directions) variants.byDirection.set(directions, resolved);
        else variants.default = resolved;
    }
    return resolved;
}
